<template>
    <el-dialog
            :title="dataForm.id?'编辑':'新增'"
            :visible.sync="visible"
            :append-to-body="true"
            width="600px">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm"
                 @keyup.enter.native="dataFormSubmit()"
                 label-width="80px">
            <el-form-item label="品牌" prop="title">
                <el-input type="text" v-model="dataForm.title" style="width: 70%;" clearable></el-input>
            </el-form-item>
            <el-form-item label="风格类型" prop="style">
                <el-select v-model="dataForm.style" value-key filterable placeholder="请选择" clearable>
                    <el-option
                            v-for="item in styleList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="报价文件" prop="orderPrice">
                <el-upload
                        class="upload-demo"
                        drag
                        action="https://b.365jiaju.net/api/edu/upload/file"
                        :on-success="priceSuccess"
                        :on-remove="priceRemove"
                        :file-list="priceList"
                        multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">上传文件最好不超过40MB，否则请联系管理员上传！
                    </div>
                </el-upload>
            </el-form-item>
            <el-form-item label="合作方式" prop="wayCooper">
                <el-radio-group v-model="dataForm.wayCooper">
                    <el-radio :label="1">工厂合作</el-radio>
                    <el-radio :label="2">经销商合作</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="visible = false">取消</el-button>
        <el-button type="primary" @click="dataFormSubmit()">保存</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import {Means} from "../../api/means";

    export default {
        name: "means-add-or-update",
        props: ["type"],
        data() {
            return {
                visible: false,
                dialogImageUrl: '',
                dialogVisible: false,
                styleList: [
                    {value: '现代', label: '现代'},
                    {value: '北欧', label: '北欧'},
                    {value: '轻奢', label: '轻奢'},
                    {value: '美式', label: '美式'},
                    {value: '新中式', label: '新中式'},
                    {value: '新古典', label: '新古典'},
                    {value: '其他', label: '其他'},
                ],
                fileList1: [],
                filePath: [],
                priceList: [],
                dataForm: {
                    id: 0,
                    title: '',
                    style: '',
                    orderPrice: '',
                    type: '',
                    filePath: '',
                    wayCooper: 1
                },
                dataRule: {
                    title: [
                        {required: true, message: '品牌不能为空', trigger: 'blur'}
                    ],
                    style: [
                        {required: true, message: '风格类型不能为空', trigger: 'blur'}
                    ],
                    orderPrice: [
                        {required: true, message: '请上传文件', trigger: 'blur'}
                    ]
                }
            }
        },
        watch: {
            //弹出层关闭清空数据
            visible(newValue, oldValue) {
                if (newValue === false) {
                    this.$nextTick(() => {
                        this.$refs['dataForm'].resetFields();
                        this.filePath = [];
                        this.fileList1 = [];
                        this.priceList = [];
                    });
                }
            }
        },
        methods: {
            priceSuccess(res, file) {
                this.$message({
                    type: 'success',
                    message: '文件上传成功',
                    duration: 1500
                });
                //console.log(res.url);
                this.fileList1.push(file.name);
                this.filePath.push(res.url);
                this.dataForm.orderPrice = this.fileList1.join(',');
                this.dataForm.filePath = this.filePath.join(',');
            },
            priceRemove(file, fileList) {
                let files = [];
                let paths = [];
                //console.log(fileList);
                fileList.forEach(item => {
                    files.push(item.name);
                    if (item.response) {
                        paths.push(item.response.url);
                    } else {
                        paths.push(item.url);
                    }
                });
                this.fileList1 = files;
                this.filePath = paths;
                this.dataForm.orderPrice = files.join(',');
                this.dataForm.filePath = paths.join(',');
                //console.log(this.filePath + '--' + this.dataForm.filePath);
                this.$message({
                    type: 'info',
                    message: '已删除原有文件',
                    duration: 1500
                });
            },
            init(id) {
                this.visible = true;
                this.dataForm.id = id;
                //console.log(this.type)
                if (this.type === 'first') {
                    this.dataForm.type = '家具';
                    this.styleList = [
                        {value: '现代', label: '现代'},
                        {value: '北欧', label: '北欧'},
                        {value: '轻奢', label: '轻奢'},
                        {value: '美式', label: '美式'},
                        {value: '新中式', label: '新中式'},
                        {value: '新古典', label: '新古典'},
                        {value: '其他', label: '其他'},
                    ];
                } else if (this.type === 'second') {
                    this.dataForm.type = '饰品';
                    this.styleList = [
                        {value: '地毯', label: '地毯'},
                        {value: '挂画', label: '挂画'}
                    ];
                }
                if (this.dataForm.id) { // 查询
                    Means.getMeansInfo(this.dataForm.id).then(res => {
                        if (res.code === 0) {
                            this.dataForm.title = res.means.title;
                            this.dataForm.style = res.means.style;
                            this.dataForm.type = res.means.type;
                            this.dataForm.orderPrice = res.means.file;
                            this.dataForm.filePath = res.means.filePath;
                            this.dataForm.wayCooper = res.means.wayCooper;
                            if (res.means.file) {
                                this.fileList1 = res.means.file.split(',');
                                res.means.file.split(',').forEach((item, index) => {
                                    this.priceList.push({name: item});
                                });
                            }
                            if (res.means.filePath) {
                                this.filePath = res.means.filePath.split(',');
                                res.means.filePath.split(',').forEach((item, index) => {
                                    this.priceList[index].url = item;
                                });
                            }
                        }
                    });
                }
            },
            /**
             * 提交
             */
            dataFormSubmit() {
                let datas = {
                    'id': this.dataForm.id,
                    'title': this.dataForm.title,
                    'style': this.dataForm.style,
                    'file': this.dataForm.orderPrice,
                    'filePath': this.dataForm.filePath,
                    'type': this.dataForm.type,
                    'wayCooper': this.dataForm.wayCooper
                };
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        let type = this.dataForm.id ? 'update' : 'save';
                        Means.addOrUpdateMeans(type, datas).then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 1500,
                                    onClose: () => {
                                        this.visible = false;
                                        this.$nextTick(() => {
                                            this.$emit('getDataList');
                                        })
                                    }
                                })
                            } else {
                                this.$message.error(res.msg);
                            }
                        });
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
